export default __webpack_public_path__ + "static/media/FG_22.bafb12e1.jpeg";